module.exports = __webpack_public_path__ + "static/media/instagram.ac92a9e6.svg";